import { useAuthHeaders } from "./useAuthHeaders";
import type { Res } from "../utils/types";
import { useMessageHandler } from "./useMessageHandler";
import { useAgentStore } from "../stores/agentStore";
import { useCallback, useEffect } from "react";

export function useAgentStateSync() {
  const { getAuthHeader } = useAuthHeaders();
  const { handleMessage } = useMessageHandler();
  // const { setAgents, setOnline } = useAgentStore(store => store);
  const update = useCallback(async () => {
      const headers = await getAuthHeader();
      if (!headers) return;
      const res = await fetch(`/api/agents`, { headers, method: 'OPTIONS' }).then(res => res.json())
        .then(data => {
          // handleMessage(data);
          useAgentStore.getState().setOnline(data?.data);
          return data.data as Res<Record<string, boolean>>;
        }).catch(e => {
          // handleMessage(e);
          return null;
        });
      if (!res?.ok) return;
      useAgentStore.getState().setOnline(res.data || {});
  }, [getAuthHeader, handleMessage]);
  useEffect(() => {
    update();
    const id = setInterval(async () => {
      await update();
    }, 5000);
    return () => clearInterval(id);
  }, [update]);
}